import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isUserLoggedIn = this.authenticationService.currentUserName$.value;
    const idToken = sessionStorage.getItem('id-token');

    if (isUserLoggedIn && idToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `${idToken}`
        }
      });
    }

    const localDev = window.location.href.indexOf('.com') === -1;
    const serverlessApi = /api\\./.test(request.url);

    if (localDev && serverlessApi) {
      request = request.clone({
        url: request.url.replace(environment.BASE_URL, '')
      });
    }

    return next.handle(request);
  }
}


